import { render, staticRenderFns } from "./MessageBoxHeaderV2.vue?vue&type=template&id=48450fa8&scoped=true"
import script from "./MessageBoxHeaderV2.vue?vue&type=script&lang=js"
export * from "./MessageBoxHeaderV2.vue?vue&type=script&lang=js"
import style0 from "./MessageBoxHeaderV2.vue?vue&type=style&index=0&id=48450fa8&prod&lang=scss"
import style1 from "./MessageBoxHeaderV2.vue?vue&type=style&index=1&id=48450fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48450fa8",
  null
  
)

export default component.exports